import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
export default class SearchResult10000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
    };

    this.listDuAnTitle = [
      "Mã khu vực",
      "Tên khu vực",
      "Chỉ giới xây dựng",
      "Tầng cao xây dựng",
      "Chiều cao mỗi tầng",
      "Cốt nền",
      "Mật độ xây dựng",
      "Quy định khác",
      "Phường/Xã",
      "Quận/Huyện",
      "Quyết định pháp lý",
    ];

    this.listDuAnValue = [
      "MaKV",
      "TenKhuVuc",
      "ChiGioiXD",
      "TangCaoXD",
      "ChieuCaoTang",
      "CotNen",
      "MatDoXD",
      "QDKhac",
      "TenPhuong",
      "TENHUYEN",
    ];
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  render() {
    return (
      <div className="search-500">
        <div className="search-500-header">
          Thông tin kiến trúc xây dựng
          <i className="fas fa-times close-icon" onClick={this.props.close}></i>
        </div>

        <div className="search-500-body">
          {this.listDuAnTitle.map((e, i) => (
            <div style={{ display: "flex" }}>
              <div className="col-left-kien-truc search-500-text" key={i}>
                {e}:
              </div>

              <div className="col-right-kiet-truc search-500-text-gray" key={i}>
                {this.props.data[`${this.listDuAnValue[i]}`]
                  ? this.props.data[`${this.listDuAnValue[i]}`]
                  : "-"}
              </div>
            </div>
          ))}

          {this.props.file && Array.isArray(this.props.file) && this.props.file.length !== 0 && (
            <div style={{ display: "flex" }}>
              <div className="col-left-kien-truc search-500-text">File đính kèm:</div>
              <div>
                {this.props.file.map((e, i) => (
                  <div
                    className="col-right search-500-text"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "125px",
                      color: "#1e86eb",
                      cursor: "pointer",
                    }}
                    onClick = {async()=>{
                      const response = await AxiosGetSecretApi(`/api/otp-token`);
                      window.open(`${e.Duongdanfiledinhkem}?key=${response.token}`, "_blank")
                    }}
                  >
                    {e.Tenfiledinhkem}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
